import { render } from "./externaldataset-list.vue?vue&type=template&id=5cc8da5a"
import script from "./externaldataset-list.vue?vue&type=script&lang=js"
export * from "./externaldataset-list.vue?vue&type=script&lang=js"

import "./externaldataset-list.vue?vue&type=style&index=0&id=5cc8da5a&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__